export const fragenAutoOhneZulassungVerkaufen = [
  {
    question: "Darf ich mit einem abgemeldeten Auto noch Probe fahren?",
    answer: (
      <>
        <p>
          Nein. Ohne Zulassung ist die Teilnahme am öffentlichen Straßenverkehr
          verboten. Du kannst allenfalls auf Privatgelände fahren, sofern der
          Eigentümer es erlaubt.
        </p>
      </>
    ),
  },
  {
    question: "Wie erfahre ich den Wert meines abgemeldeten Autos?",
    answer: (
      <>
        <p>
          Nutze Online-Bewertungsrechner, Vergleiche auf Anzeigenplattformen und
          befrage Händler. Faktoren wie Alter, Laufleistung, Zustand, Marke und
          Modell bestimmen den Wert.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich vor dem Verkauf die HU erneuern?",
    answer: (
      <>
        <p>
          Nein. Es ist keine Pflicht, aber ein gültiger HU-Bericht kann den
          Verkaufspreis steigern. Bei starkem Reparaturbedarf lohnt sich die
          Investition jedoch oft nicht.
        </p>
      </>
    ),
  },
  {
    question: "Wer trägt das Risiko auf der Überführungsfahrt?",
    answer: (
      <>
        <p>
          Der Käufer muss eigenständig eine Kurzzeitversicherung abschließen.
          Überführungskennzeichen decken meist Haftpflicht für die Fahrt ab.
        </p>
      </>
    ),
  },
  {
    question: "Wie melde ich das Fahrzeug in Österreich ab?",
    answer: (
      <>
        <p>
          Bei einer Zulassungsstelle – eine reine Online-Abmeldung gibt es in
          Österreich nicht. Du legst dort die Zulassungsbescheinigung (beide
          Teile), den Genehmigungsnachweis, die Kennzeichentafeln und einen
          amtlichen Lichtbildausweis vor. Die Abmeldung ist gebührenfrei und mit
          schriftlicher Vollmacht auch durch eine Vertretung möglich.
        </p>
      </>
    ),
  },
];

